export const leadershipMessage = `Which of the following best describes your leadership leadership’s approach to 
analytics?`;

const leadershipQ1 = `Little awareness of or interest in analytics.`;

const leadershipQ2 = `Local leaders emerge, but have little connection.`;

const leadershipQ3 = `Senior leaders recognizing importance of analytical capabilities`;

const leadershipQ4 = `Senior leaders developing analytical plans and building analytical capabilities.`;

const leadershipQ5 = `Strong leaders behaving analytically and showing passion for analytical competition`;

export const leadershipQuestions = [ leadershipQ1, leadershipQ2, leadershipQ3, leadershipQ4, leadershipQ5 ];
export const leadershipQuestionWeight = 0.16;
export const leadershipQuestionsScore = [ 0.16, 0.32, 0.48, 0.64, 0.80 ];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/data/leadershipQuestions.ts